
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mydecor",
      function () {
        return require("private-next-pages/mydecor.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mydecor"])
      });
    }
  